import httpClient from '@/api/httpClient';

const getInitialPageInfo = decodedId => httpClient.get(`/auth/webshop/${decodedId}`);

const authenticate = params => httpClient.post('/auth/authenticatePatient', params);

const getHashedRenewedTreatmentId = treatmentPrototypeId =>
  httpClient.get(`/auth/webshop/renew/${treatmentPrototypeId}`);

const sendOfferVerification = treatmentId =>
  httpClient.post(`/auth/webshop/sendPatientOfferVerification/${treatmentId}`);

const verifyRenewOffer = (treatmentPrototypeId, verificationCode) =>
  httpClient.get(`/auth/webshop/verificationRenew/${treatmentPrototypeId}/${verificationCode}`);

const isOfferPaid = treatmentId => httpClient.get(`/api/webShop/treatments/${treatmentId}/paid`);

export {
  getInitialPageInfo,
  authenticate,
  getHashedRenewedTreatmentId,
  sendOfferVerification,
  verifyRenewOffer,
  isOfferPaid
};
